export const customers = {
  title: "Customers",
  description: "Leads, active accounts, and their commercial history.",
  newCustomer: "New customer",
  searchHint: "Matches name or code.",
  emptyTitle: "No customers match",
  emptyDescription: "Create a customer to start recording quotes, jobs, and follow-ups.",
  notFound: "Customer not found.",
  column: {
    name: "Customer",
    phone: "Phone",
    email: "Email",
    status: "Status",
  },
  statusOption: {
    activeAndLeads: "Active & leads",
    leadsOnly: "Leads only",
    activeOnly: "Active only",
  },
  create: {
    title: "Add a customer",
    description: "A lead becomes active once commercial work begins.",
    button: "Create customer",
  },
  field: {
    legalName: "Business name",
    displayName: "Short name",
    notesHint: "Preferences, directions, or anything the shop should remember.",
  },
  header: {
    back: "Back to customers",
    reactivate: "Reactivate",
    archive: "Archive",
  },
  contacts: {
    title: "Contacts",
    add: "Add contact",
    empty: "No contacts yet.",
    saved: "Save contact",
    addedToast: "Contact added",
    removedToast: "Contact removed",
  },
  addresses: {
    title: "Addresses",
    add: "Add address",
    empty: "No addresses yet.",
    saved: "Save address",
    addedToast: "Address added",
    removedToast: "Address removed",
    labelHint: "e.g. Workshop gate, Delivery point.",
  },
  tasks: {
    title: "Follow-ups",
    schedule: "Schedule",
    empty: "No follow-ups for this customer.",
    scheduledToast: "Follow-up scheduled",
    completedToast: "Task completed",
    reopenedToast: "Task reopened",
    reopen: "Reopen",
    complete: "Complete",
    dueTo: "Assigned to {name}",
    dueAt: "due {date}",
    save: "Save follow-up",
  },
  timeline: {
    title: "Timeline",
    logActivity: "Log activity",
    empty: "Calls, meetings, and notes will appear here as they are logged.",
    loggedToast: "Activity logged",
    taskCompleted: "Task completed",
    taskScheduled: "Task scheduled",
    whatHappened: "What happened?",
    saveActivity: "Save activity",
  },
  followUps: {
    title: "My follow-ups",
    open: "{count} open",
    emptyTitle: "Nothing due",
    emptyDescription: "Follow-ups assigned to you will queue here for completion.",
  },
  archivedToast: "Customer archived",
  reactivatedToast: "Customer reactivated",
  createdToast: "Customer created",
  createdToastDesc: "{name} is on file.",
};
